var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5995 4.37059H14.1661V1.75811C13.4076 1.68035 12.6454 1.64195 11.8828 1.64309C9.61615 1.64309 8.06615 3.00684 8.06615 5.50431V7.65673H5.50781V10.5814H8.06615V18.0738H11.1328V10.5814H13.6828L14.0661 7.65673H11.1328V5.79185C11.1328 4.92923 11.3661 4.37059 12.5995 4.37059Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.919c9b89919d660dc057e1ef48df5205.svg";
export { ForwardRef as ReactComponent };